import React from 'react'
import Page from '../components/Page'
import BlogTeaser from '../components/BlogTeaser'
import Img from 'gatsby-image'
import './Homepage.scss'

export default function Homepage(props) {
  return (
    <Page title={'Rob Bayliss'} className={'Homepage'}>
      <Img
        sizes={props.data.file.childImageSharp.sizes}
        className={'Banner'}
        alt={'Me in Costa Rica'}
      />
      <div className="BlogListing">
        {props.data.allMarkdownRemark.edges.map(edge => (
          <BlogTeaser
            key={edge.node.id}
            title={edge.node.frontmatter.title}
            path={edge.node.frontmatter.path}
            date={edge.node.frontmatter.date}
            excerpt={edge.node.excerpt}
          />
        ))}
      </div>
    </Page>
  )
}

export const query = graphql`
  query IndexQuery {
    file(relativePath: { eq: "assets/i/rob_volcano.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 2000) {
          ...GatsbyImageSharpSizes
        }
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { date: { ne: null } } }
    ) {
      totalCount
      edges {
        node {
          id
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            path
            title
          }
          excerpt
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js